import React from 'react';

export const ModifiedStatus: React.FC = () => {
  return null; // <InlineProgressIcon /> - used previously.
};
